import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from "../../_global";
import { colours } from "../../../constants/css";
import { clickToShop } from "../../../reducers/shop";
var Container = styled.div.withConfig({
  displayName: "LoginConfirmation__Container",
  componentId: "sc-ag8469-0"
})(["margin:3rem 0 2rem;padding:0 1.5rem;text-align:center;"]);
var ConfirmationContainer = styled.div.withConfig({
  displayName: "LoginConfirmation__ConfirmationContainer",
  componentId: "sc-ag8469-1"
})(["display:flex;margin-bottom:1rem;"]);
var ConfirmationInfo = styled.h2.withConfig({
  displayName: "LoginConfirmation__ConfirmationInfo",
  componentId: "sc-ag8469-2"
})(["font-size:1.375rem;text-align:left;margin:0 0 0 0.8rem;"]);
var ConfirmationTick = styled.div.withConfig({
  displayName: "LoginConfirmation__ConfirmationTick",
  componentId: "sc-ag8469-3"
})(["display:flex;align-items:center;justify-content:center;width:50px;height:50px;border-radius:50%;background:", ";flex-shrink:0;"], colours.qantasLightCyan);
var ShopNowBtn = styled(Button).withConfig({
  displayName: "LoginConfirmation__ShopNowBtn",
  componentId: "sc-ag8469-4"
})(["margin-top:1rem;"]);
var LoginConfirmation = /*#__PURE__*/function (_Component) {
  function LoginConfirmation() {
    var _this;
    _classCallCheck(this, LoginConfirmation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, LoginConfirmation, [].concat(args)), _this.state = {
      isDismissed: false
    }, _this.dismissModal = function () {
      _this.setState({
        isDismissed: true
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(LoginConfirmation, _Component);
  return _createClass(LoginConfirmation, [{
    key: "render",
    value: function render() {
      var isDismissed = this.state.isDismissed;
      var _this$props = this.props,
        shopNow = _this$props.shopNow,
        merchantId = _this$props.merchantId,
        merchantIdOLM = _this$props.merchantIdOLM,
        popUpError = _this$props.popUpError;
      return __jsx(Modal, {
        show: !isDismissed && popUpError,
        onClose: this.dismissModal,
        width: 290
      }, __jsx(Container, null, __jsx(ConfirmationContainer, null, __jsx(ConfirmationTick, null, __jsx(Icon, {
        iconType: "tick"
      })), __jsx(ConfirmationInfo, null, "You've successfully logged in")), __jsx(ShopNowBtn, {
        primary: true,
        block: true,
        onPress: function onPress() {
          return shopNow(merchantId, merchantIdOLM);
        }
      }, "Okay, continue to shop")));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(_ref) {
  var popUpError = _ref.shop.popUpError;
  return {
    popUpError: popUpError
  };
};
var mapDispatchToProps = {
  shopNow: clickToShop
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginConfirmation);